export default __webpack_public_path__ + "static/media/tour.19af757d.svg";